import React, {memo, ReactNode, useMemo} from "react";
import {Box} from "@mui/material";
import clsx from "clsx";
import {useNavigate} from "react-router-dom";

import styles from "./Layout.module.css";
import {Aside, AsideMobile, Loader} from "../index";
import useResize from "../../hooks/useResize";
import {TABLET_VERSION} from "../../constants";

type LayoutProps = {
    children: ReactNode;
    isLoading?: boolean;
    withoutMenu?: boolean;
    hideBackButton?: boolean;
    style?: string;
    route?: string;
    handleBack?: () => void;
};

const LayoutComponent = ({
                             children,
                             isLoading,
                             style,
                             route,
                             handleBack,
                             hideBackButton = false,
                         withoutMenu = false
                         }: LayoutProps) => {
    const {innerWidth} = useResize();
    const navigate = useNavigate();

    const isDesktop = innerWidth > TABLET_VERSION;

    const mainClassName = useMemo(() => clsx(styles.main, withoutMenu && styles.mainWithoutMenu), [withoutMenu]);

    const mainStyle = useMemo(() => (style ? {backgroundImage: style} : undefined), [style]
    );

    const resolvedHandleBack = () => {
        if (handleBack) {
            handleBack();
            return;
        }
        if (route) {
            navigate(route, {replace: true});
            return;
        }
        window.history.back();
    };

    return (
        <div className={styles.root}>
            {isDesktop ? (
                <Box className={styles.aside}>
                    <Aside
                        withoutMenu={withoutMenu}
                        hideBackButton={hideBackButton}
                        route={route}
                        handleBack={resolvedHandleBack}
                    />
                </Box>
            ) : (
                <Box className={styles.aside_mobile}>
                    <AsideMobile withoutMenu={withoutMenu} hideBackButton={hideBackButton} handleBack={resolvedHandleBack}/>
                </Box>
            )}

            <Box className={mainClassName} style={mainStyle}>
                {isLoading ? <Loader/> : children}
            </Box>
        </div>
    );
};

// Memoized export
const Layout = memo(LayoutComponent);
Layout.displayName = "Layout";

export default Layout;
